module.exports = __webpack_public_path__ + "img/earth-stars.6ac70bdf.svg";